// === wizardStepAdvertiseAppointment.js START =============================================================

wizardSteps["advertise"] = {
    templateName: "#m-modal__advertise-appointment-template",
    onInit: function () {
        Handlebars.registerPartial("advertiseContactSelectionTemplate", Handlebars.compile($("#m-modal__advertise-contact-selection-template").html()));
        Handlebars.registerPartial("advertiseContactListTemplate", Handlebars.compile($("#m-modal__advertise-contact-list-template").html()));
    },

    beforeRender: function (ctx) {
        if (typeof contactList === "undefined") {
            contactList = [];
        }

        if (!ctx.model.o.advertisementUsers) {
            ctx.model.o.advertisementUsers = [];
        }

        ctx.model.contactsLoading = true;
    },
    afterRender: function (ctx) {
        // Load contact list
        if (contactList.length === 0) {
            ApiClient.getContactList()
                .done(function(data) {
                    for (var i = 0; i < data.data.length; i++) {
                        // This is used for accessing array data in addParticipant method
                        // Mustache provides @index in loops, but that would go wrong during filtering
                        data.data[i].internalIndex = i;
                    }
                    // This variable is used for filtering and updating whenever needed
                    contactList = data.data;
                    // This is make Handlebars display it's content
                    ctx.model.advertiseContactSelection = data.data;

                    wizardSteps["advertise"].prepFilteredSelection(ctx);
                    wizardSteps["advertise"].rebuildAdvertiseContactSelection(ctx);
                    wizardSteps["advertise"].rebuildAdvertisementUsers(ctx);

                    // Resize the iframe and reposition the modal.
                    window.performResize();
                    window.PositionModal();
                })
                .fail(function(msg) {
                    ShowErrorPanel(msg);
                })
                .always(function() {
                    ctx.model.contactsLoading = false;
                });
        } else {
            // Already present
            ctx.model.advertiseContactSelection = contactList;
            wizardSteps["advertise"].prepFilteredSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertiseContactSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertisementUsers(ctx);
        }
        // Filter
        $("#m-modal__input-advertise-contact-filter").on("keyup", function () {
            wizardSteps["advertise"].prepFilteredSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertiseContactSelection(ctx);
        });
    },
    prepFilteredSelection: function (ctx) {
        var search = $("#m-modal__input-advertise-contact-filter").val().trim();

        var alreadySelected = [];
        for (var o = 0; o < ctx.model.o.advertisementUsers.length; o++) {
            var uid = ctx.model.o.advertisementUsers[o].userId;
            if (typeof uid === "undefined")
                continue;
            alreadySelected.push(uid);
        }

        var replacementList = [];
        for (var i = 0; i < contactList.length; i++) {
            var contact = contactList[i];

            // Search active?
            if (search !== ""
                && !contact.firstName.containsIgnoreCase(search)
                && !contact.lastName.containsIgnoreCase(search)) {
                continue;
            }

            // Already a advertisementUsers?
            // All users in the contact list have a userId defined. External users don't.
            if (typeof contact.userId !== "undefined"
                && alreadySelected.indexOf(contact.userId) !== -1) {
                continue;
            }

            replacementList.push(contact);
        }
        ctx.model.advertiseContactSelection = replacementList;
    },

    rebuildAdvertiseContactSelection: function (ctx) {
        var template = Handlebars.partials["advertiseContactSelectionTemplate"];
        var $wrapper = $("#m-modal__advertise-contact-selection-wrapper");
        $wrapper.html(template(ctx.model));
        $wrapper.find("li").click(function () {
            var $option = $(this);
            var participantToAdd = contactList[$option.data("value")];
            ctx.model.o.advertisementUsers.push(participantToAdd);

            wizardSteps["advertise"].prepFilteredSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertiseContactSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertisementUsers(ctx);
        });
        $wrapper.find("option").click(function () {
            var $option = $(this);
            ctx.model.o.advertisementUsers.push(
                contactList[$option.val()]
            );

            wizardSteps["advertise"].prepFilteredSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertiseContactSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertisementUsers(ctx);
        });
    },

    rebuildAdvertisementUsers: function (ctx) {
        var template = Handlebars.partials["advertiseContactListTemplate"];
        var $wrapper = $(".m-modal__advertisie-contact-list-wrapper");
        $wrapper.html(template(ctx.model));
        // TODO Why does the bind event not work the first time if the console messages are removed?
        var $btns = $wrapper.find(".m-modal__icon--advertisie-contact-remove");
        console.info("Bound event to " + $btns.length + " trash can buttons");
        $btns.click(function () {
            var $part = $(this).parents(".m-modal__advertise-contact-list-box");
            var index = $part.data("index");
            console.info("Removed entry " + index + " from participant list");
            ctx.model.o.advertisementUsers.splice(index, 1);

            wizardSteps["advertise"].prepFilteredSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertiseContactSelection(ctx);
            wizardSteps["advertise"].rebuildAdvertisementUsers(ctx);
        });
    },
    save: function () {
    },
    getButtonList: function () {
        return {
            "back": true,
            "save": true
        };
    }
};

// === wizardStepAdvertiseAppointment.js END ===============================================================
